import React, { useEffect, useState } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { Button, Card, CardBody, CardTitle, Spinner } from "reactstrap"
import { addItemSchemas } from "components/Common/validation"
import Switch from "components/Shared/Switch"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { addItem } from "store/actions/itemsAction"
import { InputGroup } from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

import { getCategories } from "store/actions/categoriesAction"
import { showAlert } from "store/reducers/alertReducer"
import BackButton from "components/Shared/BackButton"
import {
  getImagePreviewSrc,
  handleFileChange,
} from "components/Shared/fileHandlers"
import Select from "react-select"
import { getCountryList } from "store/actions/countriesAction"
import { useTranslation } from "react-i18next"
import { itemHeight, itemMaxSize, itemWidth } from "components/Common/ImageSize"
import TextError from "components/Shared/TextError"

const initialValues = {
  nameAr: "",
  nameEn: "",
  descriptionAr: "",
  descriptionEn: "",
  displayOrder: null,
  posId: "",
  imageType: "UPLOAD",
  imageUrl: "",
  imageFile: null,
  itemPrice: null,
  originalPrice: null,
  caloriesForDisplay: "",
  personCountPerServing: "",
  caloriesForCalculations: "",
  enabled: true,
  disablePickup: false,
  disableDelivery: false,
  category: "",
  isDiscountAllowed: true,
  isCombo: false,
  isFeatured: false,
  specialPrice: false,
  disabledBranches: [],
  outOfStockForBranches: [],
  countryCode: null,
  announcementAr: "",
  announcementEn: "",
  availabilityHasSpecificTime: false,
  availabilityStartTime: "",
  availabilityEndTime: "",
}

const AddItem = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = ` ${
    mode === "add" || mode === "allItemsAdd" ? t("Add") : t("Edit")
  } ${t("Item | Sign Burger")}`

  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { categoryId } = useParams()
  const { countryList } = useSelector(state => state.Countries)
  const [formValues, setFormValues] = useState(initialValues)

  const { isLoading } = useSelector(state => state.Items)

  const { allCategories } = useSelector(state => state.Categories)
  const { isImageCompressing } = useSelector(state => state.Common)

  // SET CATEGORY IF HAVE ON WINDOW URL
  useEffect(() => {
    if (categoryId) {
      setFormValues({
        ...formValues,
        category: categoryId,
      })
    }
  }, [categoryId])

  useEffect(() => {
    // getCategoriesList()
    fetchCountryList()
  }, [])

  const fetchCountryList = () => {
    dispatch(getCountryList())
  }

  const getCategoriesList = countryCode => {
    dispatch(getCategories({ isCombo: false, countryCode }))
  }

  const handleSubmit = values => {
    const {
      nameAr,
      nameEn,
      descriptionAr,
      descriptionEn,
      displayOrder,
      imageType,
      imageUrl,
      imageFile,
      itemPrice,
      originalPrice,
      caloriesForDisplay,
      personCountPerServing,
      caloriesForCalculations,
      enabled,
      disablePickup,
      disableDelivery,
      category,
      countryCode,
      announcementEn,
      announcementAr,
      availabilityHasSpecificTime,
      availabilityStartTime,
      availabilityEndTime,
    } = values

    let data = new FormData()
    data.append("name", nameEn)
    data.append("nameAr", nameAr)
    data.append("description", descriptionEn)
    data.append("descriptionAr", descriptionAr)
    data.append("displayOrder", displayOrder)
    data.append("imageUrl", imageUrl)
    data.append("imageUrlType", imageType)
    // data.append("status", enabled ? 1 : 0)
    data.append("image", imageFile)
    data.append("personCountPerServing", personCountPerServing)
    data.append("disableForPickup", disablePickup)
    // data.append("disableForDelivery", disableDelivery)
    data.append("price", itemPrice)
    data.append("originalPrice", originalPrice)
    data.append("calories", caloriesForCalculations)
    data.append("calorieCount", caloriesForCalculations)
    data.append("countryCode", countryCode?.value?.toUpperCase())
    data.append("announcementEn", announcementEn)
    data.append("announcementAr", announcementAr)

    data.append("availability[hasSpecificTime]", availabilityHasSpecificTime)
    if (availabilityHasSpecificTime) {
      data.append("availability[startTime]", availabilityStartTime)
      data.append("availability[endTime]", availabilityEndTime)
    }

    if (mode === "add") {
      data.append("categoryId", categoryId)
      dispatch(addItem(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            // navigate(`/menus/categories/${categoryId}/items`)
            navigate(-1)
            dispatch(showAlert({ text: msg, type: "success" }))
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    } else if (mode === "allItemsAdd") {
      data.append("categoryId", category)
      dispatch(addItem(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate(-1)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  return (
    <div className="page-content add_item_page">
      <div className="container-fluid">
        <Breadcrumbs />
        <Card>
          <CardBody>
            <CardTitle className="d-flex align-items-center">
              <BackButton />
              {mode === "add" || mode === "allItemsAdd"
                ? t("Add")
                : t("Edit")}{" "}
              {t("Items")}
            </CardTitle>
            <Formik
              enableReinitialize={true}
              initialValues={formValues}
              onSubmit={handleSubmit}
              validationSchema={addItemSchemas(mode)}
            >
              {({ errors, touched, values, isSubmitting, setFieldValue }) => (
                <Form>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="nameEn">
                          {" "}
                          <span className="text-danger">*</span>{" "}
                          {t("Name(English)")}
                        </label>
                        <Field
                          type="text"
                          id="nameEn"
                          name="nameEn"
                          placeholder={t("Name(English)")}
                          className={`form-control ${
                            touched.nameEn && errors.nameEn ? "is-invalid" : ""
                          }`}
                        />
                        <TextError name="nameEn" />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="nameAr">
                          <span className="text-danger">*</span>{" "}
                          {t("Name(عربي)")}
                        </label>
                        <Field
                          type="text"
                          id="nameAr"
                          style={{ direction: "rtl" }}
                          name="nameAr"
                          placeholder={t("Name(عربي)")}
                          className={`form-control ${
                            touched.nameAr && errors.nameAr ? "is-invalid" : ""
                          }`}
                        />
                        <TextError name="nameAr" />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="descriptionEn">
                          {t("Description(English)")}
                        </label>
                        <Field
                          // type="text"
                          as="textarea"
                          rows={1}
                          id="descriptionEn"
                          name="descriptionEn"
                          placeholder={t("Description(English)")}
                          className={`form-control ${
                            touched.descriptionEn && errors.descriptionEn
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="descriptionAr">
                          {t("Description(عربي)")}
                        </label>
                        <Field
                          as="textarea"
                          rows={1}
                          id="descriptionAr"
                          style={{ direction: "rtl" }}
                          name="descriptionAr"
                          placeholder={t("Description(عربي)")}
                          className={`form-control ${
                            touched.descriptionAr && errors.descriptionAr
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <TextError name="descriptionAr" />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="mt-2">
                        <label htmlFor="countryCode">
                          <span className="text-danger">*</span>{" "}
                          {t("Select Country")}
                        </label>
                        <Select
                          value={values.countryCode}
                          onChange={selectedValue => {
                            setFieldValue("countryCode", selectedValue)
                            getCategoriesList(selectedValue.value)
                            mode === "allItemsAdd" &&
                              setFieldValue("category", "")
                          }}
                          options={countryList?.map(item => ({
                            label: language === "sa" ? item.nameAr : item.name,
                            value: item.countryCode,
                          }))}
                          placeholder={t("Select Country")}
                          className={`select2-selection ${
                            touched.countryCode && errors.countryCode
                              ? "danger_color_border"
                              : ""
                          } `}
                        />
                        <TextError name="countryCode" />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="displayOrder">
                          <span className="text-danger">*</span>
                          {t("Display Order")}
                        </label>
                        <Field
                          type="text"
                          id="displayOrder"
                          name="displayOrder"
                          placeholder={t("Display Order")}
                          className={`form-control ${
                            touched.displayOrder && errors.displayOrder
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <TextError name="displayOrder" />
                      </div>
                    </div>

                    {/* <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="posId">Pos ID</label>
                        <Field
                          type="text"
                          id="posId"
                          name="posId"
                          placeholder="Enter POS ID"
                          className={`form-control ${
                            touched.posId && errors.posId ? "is-invalid" : ""
                          }`}
                        />
                        <TextError
                          name="posId"
                          
                        />
                      </div>
                    </div> */}

                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="itemPrice">
                          {" "}
                          <span className="text-danger">*</span>{" "}
                          {t("Item Price")}
                        </label>
                        <Field
                          type="text"
                          id="itemPrice"
                          name="itemPrice"
                          placeholder="e.g. 10"
                          className={`form-control ${
                            touched.itemPrice && errors.itemPrice
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <TextError name="itemPrice" />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="originalPrice">
                          {" "}
                          <span className="text-danger">*</span>{" "}
                          {t("Original Price")}
                        </label>
                        <Field
                          type="text"
                          id="originalPrice"
                          name="originalPrice"
                          placeholder="e.g. 10"
                          className={`form-control ${
                            touched.originalPrice && errors.originalPrice
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <TextError name="originalPrice" />
                      </div>
                    </div>

                    {/* <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="caloriesForDisplay">
                          {t("Calories For Display")}
                        </label>
                        <Field
                          type="text"
                          id="caloriesForDisplay"
                          name="caloriesForDisplay"
                          placeholder="E.g. 150- 200"
                          className="form-control"
                        />
                      </div>
                    </div> */}

                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="personCountPerServing">
                          <span className="text-danger">*</span>{" "}
                          {t("Person Count Per Serving")}
                        </label>
                        <Field
                          type="text"
                          id="personCountPerServing"
                          name="personCountPerServing"
                          placeholder="E.g. 1"
                          className={`form-control ${
                            touched.personCountPerServing &&
                            errors.personCountPerServing
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <TextError name="personCountPerServing" />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="caloriesForCalculations">
                          <span className="text-danger">*</span>{" "}
                          {t("Calories for Calculations")}
                        </label>
                        <Field
                          type="text"
                          id="caloriesForCalculations"
                          name="caloriesForCalculations"
                          placeholder="E.g. 200"
                          className={`form-control ${
                            touched.caloriesForCalculations &&
                            errors.caloriesForCalculations
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <TextError name="caloriesForCalculations" />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="announcementEn">
                          {t("Announcement(English)")}
                        </label>
                        <Field
                          as="textarea"
                          rows={1}
                          id="announcementEn"
                          name="announcementEn"
                          placeholder={t("Announcement(English)")}
                          className={`form-control ${
                            touched.announcementEn && errors.announcementEn
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="announcementAr">
                          {t("Announcement(عربي)")}
                        </label>
                        <Field
                          as="textarea"
                          rows={1}
                          id="announcementAr"
                          style={{ direction: "rtl" }}
                          name="announcementAr"
                          placeholder={t("Announcement(عربي)")}
                          className={`form-control ${
                            touched.announcementAr && errors.announcementAr
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <TextError name="descriptionAr" />
                      </div>
                    </div>

                    {/* SHOW ONLY IF ADD WITHOUT CATEGORY SELECTION */}
                    {mode === "allItemsAdd" && (
                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="category">
                            <span className="text-danger">*</span>{" "}
                            {t("Category")}
                          </label>
                          <Field
                            as="select"
                            name="category"
                            id="category"
                            readOnly
                            className={`form-control ${
                              errors.category && touched.category
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option hidden>{t("Select Category")}</option>

                            {allCategories &&
                              allCategories.map(option => (
                                <option key={option._id} value={option._id}>
                                  {language === "sa"
                                    ? option.nameAr
                                    : option.name}
                                </option>
                              ))}
                          </Field>
                          <TextError
                            name="category"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                    )}

                    {/* <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor=""></label>
                         allItemsAdd
                      </div>
                    </div> */}
                    {/* <div className="col-lg-2">
                      <div className="form_field">
                        <label htmlFor="enabled">Enabled</label>
                        <Switch
                          isChecked={values.enabled}
                          onClickHandler={() => {
                            setFieldValue("enabled", !values.enabled)
                          }}
                        />
                      </div>
                    </div> */}
                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="disablePickup">
                          {t("Disable for Pickup")}
                        </label>
                        <Switch
                          isChecked={values.disablePickup}
                          onClickHandler={() => {
                            setFieldValue(
                              "disablePickup",
                              !values.disablePickup
                            )
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="form_field">
                        <label htmlFor="availabilityHasSpecificTime">
                          {t("Available for specific time")}
                        </label>
                        <Switch
                          isChecked={values.availabilityHasSpecificTime}
                          onClickHandler={() => {
                            setFieldValue(
                              "availabilityHasSpecificTime",
                              !values.availabilityHasSpecificTime
                            )
                            if (values.availabilityHasSpecificTime) {
                              setFieldValue("availabilityStartTime", "")
                              setFieldValue("availabilityEndTime", "")
                            }
                          }}
                        />
                      </div>
                    </div>
                    {values.availabilityHasSpecificTime && (
                      <>
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="availabilityStartTime">
                              <span className="text-danger">*</span>{" "}
                              {t("Opening Time")}
                            </label>
                            <InputGroup>
                              <Flatpickr
                                className="form-control d-block"
                                value={values.availabilityStartTime}
                                placeholder={t("Select time")}
                                options={{
                                  enableTime: true,
                                  noCalendar: true,
                                  dateFormat: "H:i",
                                }}
                                onChange={selectedDates => {
                                  setFieldValue(
                                    "availabilityStartTime",
                                    selectedDates[0]
                                      ? selectedDates[0]
                                          .toTimeString()
                                          .slice(0, 5)
                                      : ""
                                  )
                                }}
                              />
                              <div className="input-group-append">
                                <span className="input-group-text h-100">
                                  <i className="mdi mdi-clock-outline" />
                                </span>
                              </div>
                            </InputGroup>
                            <TextError name="availabilityStartTime" />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="availabilityEndTime">
                              <span className="text-danger">*</span>{" "}
                              {t("Closing Time")}
                            </label>
                            <InputGroup>
                              <Flatpickr
                                className="form-control d-block"
                                value={values.availabilityEndTime}
                                placeholder={t("Select time")}
                                options={{
                                  enableTime: true,
                                  noCalendar: true,
                                  dateFormat: "H:i",
                                }}
                                onChange={selectedDates => {
                                  setFieldValue(
                                    "availabilityEndTime",
                                    selectedDates[0]
                                      ? selectedDates[0]
                                          .toTimeString()
                                          .slice(0, 5)
                                      : ""
                                  )
                                }}
                              />
                              <div className="input-group-append">
                                <span className="input-group-text h-100">
                                  <i className="mdi mdi-clock-outline" />
                                </span>
                              </div>
                            </InputGroup>
                            <TextError name="availabilityEndTime" />
                          </div>
                        </div>
                      </>
                    )}
                    {/* <div className="col-lg-2">
                      <div className="form_field">
                        <label htmlFor="isDisableDelivery">
                          Disable for Delivery
                        </label>

                        <Switch
                          isChecked={values.disableDelivery}
                          onClickHandler={() => {
                            setFieldValue(
                              "disableDelivery",
                              !values.disableDelivery
                            )
                          }}
                        />
                      </div>
                    </div> */}

                    <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="imageType">
                          <span className="text-danger">*</span>{" "}
                          {t("Image Type")}
                        </label>
                        <Field
                          as="select"
                          id="imageType"
                          name="imageType"
                          className={`form-control ${
                            touched.imageType && errors.imageType
                              ? "is-invalid"
                              : ""
                          }`}
                          onChange={e => {
                            const selectedValue = e.target.value
                            setFieldValue("imageType", selectedValue)
                            // Reset the value of imageURL and imageFile when the image type changes
                            setFieldValue("imageUrl", "")
                            setFieldValue("imageFile", null)
                          }}
                        >
                          <option value="URL">{t("Image Url")}</option>
                          <option value="UPLOAD">{t("Upload Image")}</option>
                        </Field>
                        <TextError name="imageType" />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form_field">
                        {/* IMAGE URL */}
                        {values.imageType === "URL" && (
                          <div className="form_field">
                            <label htmlFor="imageUrl">
                              <span className="text-danger">*</span> {t("URL")}
                            </label>
                            <Field
                              type="text"
                              id="imageUrl"
                              name="imageUrl"
                              className={`form-control ${
                                touched.imageUrl && errors.imageUrl
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="imageUrl" />
                          </div>
                        )}
                        {/* UPLOAD IMAGE */}
                        {values.imageType === "UPLOAD" && (
                          <div className="form_field position-relative">
                            <label htmlFor="imageFile">
                              {" "}
                              <span className="text-danger">*</span>{" "}
                              {t("Upload Image")}
                            </label>
                            <input
                              type="file"
                              id="imageFile"
                              name="imageFile"
                              className={`form-control ${
                                touched.imageFile && errors.imageFile
                                  ? "is-invalid"
                                  : ""
                              }`}
                              accept="image/jpeg, image/jpg, image/png"
                              onChange={e => {
                                handleFileChange(
                                  e,
                                  "imageFile",
                                  setFieldValue,
                                  itemWidth,
                                  itemHeight,
                                  itemMaxSize
                                )
                              }}
                            />
                            <p className="pt-2">
                              {t(
                                "Recommended dimensions: Square Image and Size should be less than or equal to {{size}} KB",
                                {
                                  width: itemWidth,
                                  height: itemHeight,
                                  size: itemMaxSize,
                                }
                              )}
                            </p>
                            {isImageCompressing && (
                              <Spinner
                                color="primary"
                                className="file_upload_btn"
                              />
                            )}
                          </div>
                        )}
                        <TextError name="imageFile" />
                      </div>
                      {(() => {
                        const updatedMode =
                          mode === "add" || mode === "allItemsAdd"
                            ? "add"
                            : mode
                        return (
                          getImagePreviewSrc(updatedMode, values) && (
                            <div className="mt-3">
                              <img
                                src={getImagePreviewSrc(updatedMode, values)}
                                alt="Preview"
                                className="img_preview"
                              />
                            </div>
                          )
                        )
                      })()}
                    </div>
                    {/* <div className="col-12">
                      <span>Recommended size: 512 x 512</span>
                    </div> */}

                    <div className="mt-3"></div>
                    <div className="col-12 d-flex justify-content-end my-4">
                      <Button
                        type="button"
                        className="mx-2"
                        color="secondary"
                        onClick={() => navigate(-1)}
                      >
                        {t("Cancel")}
                      </Button>

                      <Button
                        type="submit"
                        color="success"
                        disabled={isLoading || isImageCompressing}
                        className="w_fit_content"
                      >
                        {mode === "add" || mode === "allItemsAdd"
                          ? t("Add")
                          : t("Save")}
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default AddItem
